"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const SanityContext_1 = require("../SanityContext");
const MapmakerApi_1 = require("../../../../client/MapmakerApi");
const react_suspender_1 = __importDefault(require("react-suspender"));
(0, graphql_tag_1.default) `
  query getReference($ref: String!) {
    sanityReference(input: { ref: $ref }) {
      id
      slug
    }
  }
`;
function InternalLinkSerializer({ mark, children, }) {
    const navigate = (0, react_router_1.useNavigate)();
    const { urlCreator } = (0, SanityContext_1.useSanityContext)();
    const [getReference, { loading }] = (0, MapmakerApi_1.useGetReferenceLazyQuery)({
        variables: {
            ref: mark.reference._ref,
        },
    });
    const onClick = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getReference();
        const url = urlCreator(data === null || data === void 0 ? void 0 : data.sanityReference.slug);
        if (url) {
            navigate(url);
        }
    }), [urlCreator, getReference, history]);
    if (loading) {
        return (0, jsx_runtime_1.jsx)(react_suspender_1.default, {});
    }
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "link", style: { fontWeight: "normal" }, onClick: onClick }, { children: children })));
}
exports.default = InternalLinkSerializer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZXJuYWxMaW5rU2VyaWFsaXplci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2hlbHAvc2FuaXR5L3NlcmlhbGl6ZXJzL0ludGVybmFsTGlua1NlcmlhbGl6ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDhEQUE4QjtBQUM5QixpQ0FBK0M7QUFDL0MsK0NBQTJDO0FBQzNDLG9EQUFvRDtBQUNwRCxnRUFBMEU7QUFDMUUsc0VBQXdDO0FBRXhDLElBQUEscUJBQUcsRUFBQTs7Ozs7OztDQU9GLENBQUM7QUFXRixTQUF3QixzQkFBc0IsQ0FBQyxFQUM3QyxJQUFJLEVBQ0osUUFBUSxHQUNvQjtJQUM1QixNQUFNLFFBQVEsR0FBRyxJQUFBLDBCQUFXLEdBQUUsQ0FBQztJQUMvQixNQUFNLEVBQUUsVUFBVSxFQUFFLEdBQUcsSUFBQSxnQ0FBZ0IsR0FBRSxDQUFDO0lBQzFDLE1BQU0sQ0FBQyxZQUFZLEVBQUUsRUFBRSxPQUFPLEVBQUUsQ0FBQyxHQUFHLElBQUEsc0NBQXdCLEVBQUM7UUFDM0QsU0FBUyxFQUFFO1lBQ1QsR0FBRyxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSTtTQUN6QjtLQUNGLENBQUMsQ0FBQztJQUNILE1BQU0sT0FBTyxHQUFHLElBQUEsbUJBQVcsRUFBQyxHQUFTLEVBQUU7UUFDckMsTUFBTSxFQUFFLElBQUksRUFBRSxHQUFHLE1BQU0sWUFBWSxFQUFFLENBQUM7UUFDdEMsTUFBTSxHQUFHLEdBQUcsVUFBVSxDQUFDLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxlQUFlLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDbkQsSUFBSSxHQUFHLEVBQUU7WUFDUCxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUM7U0FDZjtJQUNILENBQUMsQ0FBQSxFQUFFLENBQUMsVUFBVSxFQUFFLFlBQVksRUFBRSxPQUFPLENBQUMsQ0FBQyxDQUFDO0lBRXhDLElBQUksT0FBTyxFQUFFO1FBQ1gsT0FBTyx1QkFBQyx5QkFBUyxLQUFHLENBQUM7S0FDdEI7SUFFRCxPQUFPLENBQ0wsK0NBQU0sU0FBUyxFQUFDLE1BQU0sRUFBQyxLQUFLLEVBQUUsRUFBRSxVQUFVLEVBQUUsUUFBUSxFQUFFLEVBQUUsT0FBTyxFQUFFLE9BQU8sZ0JBQ3JFLFFBQVEsSUFDSixDQUNSLENBQUM7QUFDSixDQUFDO0FBNUJELHlDQTRCQyJ9